import type { RawPageConfig } from '~/types/page-config'
import { curaboxBaseConfig, pflegeServicesBaseConfig } from './base'

const curabox = {
  ...curaboxBaseConfig,
  etUrl: '',
}

const pflegeServices = {
  ...pflegeServicesBaseConfig,
  etUrl: '',
}

const config: RawPageConfig[] = [
  {
    ...pflegeServices,
    domain: /(localhost($|:)|\.local($|:))/,
    storyblok: {
      ...pflegeServices.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesDraftAccessToken',
      accessLevel: 'draft',
    },
  },
  {
    ...curabox,
    domain: /(localhost($|:)|\.local($|:))/,
    storyblok: {
      ...curabox.storyblok,
      tokenNuxtRuntimeName: 'curaboxDraftAccessToken',
      accessLevel: 'draft',
    },
  },
  {
    ...pflegeServices,
    domain: /./,
    storyblok: {
      ...pflegeServices.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesPublishedAccessToken',
      accessLevel: 'published',
    },
  },
  {
    ...curabox,
    domain: /./,
    storyblok: {
      ...curabox.storyblok,
      tokenNuxtRuntimeName: 'curaboxPublishedAccessToken',
      accessLevel: 'published',
    },
  },
]

export default config
